import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, Pipe, PipeTransform, ViewChild } from '@angular/core';

@Pipe({
  name: 'minuteSeconds',
  standalone: true
})
export class MinuteSecondsPipe implements PipeTransform {
  transform(value: number): string {
    if (!value) return "00:00"
    const minutes: number = Math.floor(value / 60);
    return (minutes < 10 ? "0" + minutes : minutes) + ':' + (parseInt(String(value % 60)) < 10 ? "0" + parseInt(String(value % 60)) : parseInt(String(value % 60)));
  }
}

@Component({
    selector: 'fikoyt-fiko-ses-oynatici',
    templateUrl: './fiko-ses-oynatici.component.html',
    styleUrls: ['./fiko-ses-oynatici.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MinuteSecondsPipe]
})
export class FikoSesOynaticiComponent implements OnDestroy {

  @ViewChild('spectrumCanvas') spectrumCanvasRef: ElementRef<HTMLCanvasElement>;

  private URL: any;
  public get url(): any {
    return this.URL;
  }
  @Input() public set url(v: any) {
    this.URL = v;
    this.CD.detectChanges();
  }

  private DURAKLATILDI: boolean = true;
  public get duraklatildi(): boolean {
    return this.DURAKLATILDI;
  }
  @Input() public set duraklatildi(v: boolean) {
    this.DURAKLATILDI = v;
    if (v) {
      if (this.sesObje)
        this.sesObje.pause();
    }
    this.CD.detectChanges();
  }

  @Output() duraklatildiChange: EventEmitter<boolean> = new EventEmitter();

  @Input() aktifZaman: number = 0;

  private SARKISURE: number = 0;
  public get sarkiSure(): number {
    return this.SARKISURE;
  }
  @Input() public set sarkiSure(v: number) {
    this.SARKISURE = v;
    this.CD.detectChanges();
  }

  zamanKaydiriliyor: boolean = false;
  sesSeviyesi: number = 1;
  sessiz: boolean = false;
  bufferYuzdesi: number = 0;
  sesObje: HTMLAudioElement = null;

  // Oynatma hızı
  hizSecenekleri: number[] = [0.5, 0.75, 1, 1.25, 1.5, 2];
  aktifHizIndex: number = 2; // 1x varsayılan

  get aktifHiz(): number {
    return this.hizSecenekleri[this.aktifHizIndex];
  }

  // Kalan süre
  get kalanSure(): number {
    return Math.max(0, this.sarkiSure - this.aktifZaman);
  }

  // Spectrum modları
  spectrumModlari: string[] = ['barlar', 'cizgi', 'dairesel', 'ayna', 'parcacik', 'osiloskop'];
  spectrumModIsimleri: string[] = ['Barlar', 'Çizgi', 'Dairesel', 'Ayna', 'Parçacık', 'Osiloskop'];
  aktifSpectrumMod: number = 0;

  // Transkript (Yazıya çevirme) - Altyazı sistemi
  transkriptMetni: string = '';
  transkriptYukleniyor: boolean = false;
  transkriptGoster: boolean = false;
  @Input() sunucuUrl: string = ''; // Backend base URL (örn: https://fikoyt.com:9000)
  @Input() mevcutTranskript: string = ''; // MongoDB'den gelen mevcut transkript metni
  @Input() mevcutSegmentler: { start: number; end: number; text: string }[] = []; // MongoDB'den gelen segmentler
  @Output() transkriptHazir: EventEmitter<{ metin: string; segmentler: { start: number; end: number; text: string }[] }> = new EventEmitter();

  // Altyazı segmentleri
  altyaziSegmentleri: { start: number; end: number; text: string }[] = [];
  aktifAltyazi: string = '';
  altyaziAktif: boolean = false; // Altyazı modu açık/kapalı

  // Spectrum
  private audioContext: AudioContext = null;
  private analyser: AnalyserNode = null;
  private sourceNode: MediaElementAudioSourceNode = null;
  private animFrameId: number = null;
  private spectrumVerisi: Uint8Array<ArrayBuffer> = null;
  private parcaciklar: { x: number; y: number; hiz: number; boyut: number; aci: number; alpha: number }[] = [];

  constructor(private readonly CD: ChangeDetectorRef) {
    CD.detach();
  }

  oynat() {
    if (this.sesObje == null) {
      this.sesObje = new Audio(this.url);
      this.sesObje.crossOrigin = 'anonymous';
      this.sesObje.volume = this.sessiz ? 0 : this.sesSeviyesi;
      this.sesObje.playbackRate = this.aktifHiz;

      if (this.sarkiSure == 0 || !this.sarkiSure) {
        this.sesObje.onloadedmetadata = () => {
          if (this.sesObje.duration === Infinity || isNaN(this.sesObje.duration)) {
            // Chrome WebM blob duration fix: seek sonuna zorla, duration ortaya çıkıyor
            this.sesObje.currentTime = 1e101;
            this.sesObje.addEventListener('timeupdate', () => {
              if (this.sesObje.duration !== Infinity && !isNaN(this.sesObje.duration)) {
                this.sarkiSure = this.sesObje.duration;
                this.sesObje.currentTime = 0;
                this.CD.detectChanges();
              }
            }, { once: true });
          } else {
            this.sarkiSure = this.sesObje.duration;
            this.CD.detectChanges();
          }
        }
      }
      this.sesObje.ontimeupdate = () => {
        if (!this.zamanKaydiriliyor) {
          this.aktifZaman = this?.sesObje?.currentTime;
          this.bufferGuncelle();
          this.altyaziGuncelle();
          this.CD.detectChanges();
        }
      }
      this.sesObje.onended = () => {
        if (!this.zamanKaydiriliyor) {
          this.aktifZaman = 0;
          this.duraklatildi = true;
          this.duraklatildiChange.emit(true);
          this.CD.detectChanges();
        }
      }
      this.sesObje.onprogress = () => {
        this.bufferGuncelle();
        this.CD.detectChanges();
      }

      this.spectrumBaslat();
    }

    if (this.sesObje.paused) {
      this.sesObje.play()
      this.duraklatildi = false;
      this.duraklatildiChange.emit(false);
      this.spectrumCiz();
    } else {
      this.sesObje.pause();
      this.duraklatildi = true;
      this.duraklatildiChange.emit(true);
    }
    this.CD.detectChanges();
  }

  // 10sn geri sar
  geriSar() {
    if (!this.sesObje) return;
    this.sesObje.currentTime = Math.max(0, this.sesObje.currentTime - 10);
    this.aktifZaman = this.sesObje.currentTime;
    this.CD.detectChanges();
  }

  // 10sn ileri sar
  ileriSar() {
    if (!this.sesObje) return;
    this.sesObje.currentTime = Math.min(this.sesObje.duration, this.sesObje.currentTime + 10);
    this.aktifZaman = this.sesObje.currentTime;
    this.CD.detectChanges();
  }

  // Oynatma hızını değiştir (tıklayınca sıradaki hıza geç)
  hizDegistir() {
    this.aktifHizIndex = (this.aktifHizIndex + 1) % this.hizSecenekleri.length;
    if (this.sesObje) {
      this.sesObje.playbackRate = this.aktifHiz;
    }
    this.CD.detectChanges();
  }

  private bufferGuncelle() {
    if (!this.sesObje || !this.sesObje.buffered.length || !this.sesObje.duration) return;
    const son = this.sesObje.buffered.end(this.sesObje.buffered.length - 1);
    this.bufferYuzdesi = (son / this.sesObje.duration) * 100;
  }

  private spectrumBaslat() {
    try {
      this.audioContext = new AudioContext();
      this.analyser = this.audioContext.createAnalyser();
      this.analyser.fftSize = 128;
      this.analyser.smoothingTimeConstant = 0.8;
      this.sourceNode = this.audioContext.createMediaElementSource(this.sesObje);
      this.sourceNode.connect(this.analyser);
      this.analyser.connect(this.audioContext.destination);
      this.spectrumVerisi = new Uint8Array(this.analyser.frequencyBinCount);
    } catch (e) {
      // CORS veya AudioContext hatası - sessizce atla
    }
  }

  spectrumModDegistir() {
    this.aktifSpectrumMod = (this.aktifSpectrumMod + 1) % this.spectrumModlari.length;
    this.CD.detectChanges();
  }

  private spectrumCiz() {
    if (!this.analyser || !this.spectrumCanvasRef) return;

    const canvas = this.spectrumCanvasRef.nativeElement;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const ciz = () => {
      if (this.sesObje?.paused) return;
      this.animFrameId = requestAnimationFrame(ciz);

      this.analyser.getByteFrequencyData(this.spectrumVerisi);

      const w = canvas.width;
      const h = canvas.height;
      ctx.clearRect(0, 0, w, h);

      switch (this.spectrumModlari[this.aktifSpectrumMod]) {
        case 'barlar': this.cizBarlar(ctx, w, h); break;
        case 'cizgi': this.cizCizgi(ctx, w, h); break;
        case 'dairesel': this.cizDairesel(ctx, w, h); break;
        case 'ayna': this.cizAyna(ctx, w, h); break;
        case 'parcacik': this.cizParcacik(ctx, w, h); break;
        case 'osiloskop': this.cizOsiloskop(ctx, w, h); break;
      }
    };
    ciz();
  }

  // Mod 1: Klasik barlar
  private cizBarlar(ctx: CanvasRenderingContext2D, w: number, h: number) {
    const sayisi = this.spectrumVerisi.length;
    const genislik = w / sayisi;
    for (let i = 0; i < sayisi; i++) {
      const d = this.spectrumVerisi[i] / 255;
      const yukseklik = d * h * 0.9;
      const x = i * genislik;
      const y = (h - yukseklik) / 2;
      ctx.fillStyle = `rgba(${75 + (i / sayisi) * 40}, ${200 + d * 55}, ${116 + (i / sayisi) * 100}, ${0.4 + d * 0.6})`;
      ctx.fillRect(x + 0.5, y, genislik - 1, yukseklik);
    }
  }

  // Mod 2: Yumuşak çizgi dalga
  private cizCizgi(ctx: CanvasRenderingContext2D, w: number, h: number) {
    const sayisi = this.spectrumVerisi.length;
    const adim = w / (sayisi - 1);

    // Dolgu gradyanı
    const grad = ctx.createLinearGradient(0, 0, w, 0);
    grad.addColorStop(0, 'rgba(75, 249, 116, 0.3)');
    grad.addColorStop(0.5, 'rgba(0, 200, 255, 0.3)');
    grad.addColorStop(1, 'rgba(180, 100, 255, 0.3)');

    // Dolgu alanı
    ctx.beginPath();
    ctx.moveTo(0, h);
    for (let i = 0; i < sayisi; i++) {
      const d = this.spectrumVerisi[i] / 255;
      const y = h - d * h * 0.85;
      if (i === 0) {
        ctx.lineTo(0, y);
      } else {
        const oncekiX = (i - 1) * adim;
        const oncekiD = this.spectrumVerisi[i - 1] / 255;
        const oncekiY = h - oncekiD * h * 0.85;
        const cpx = (oncekiX + i * adim) / 2;
        ctx.bezierCurveTo(cpx, oncekiY, cpx, y, i * adim, y);
      }
    }
    ctx.lineTo(w, h);
    ctx.closePath();
    ctx.fillStyle = grad;
    ctx.fill();

    // Üst çizgi (parlak)
    const cizgiGrad = ctx.createLinearGradient(0, 0, w, 0);
    cizgiGrad.addColorStop(0, '#4bf974');
    cizgiGrad.addColorStop(0.5, '#00c8ff');
    cizgiGrad.addColorStop(1, '#b464ff');

    ctx.beginPath();
    for (let i = 0; i < sayisi; i++) {
      const d = this.spectrumVerisi[i] / 255;
      const y = h - d * h * 0.85;
      if (i === 0) {
        ctx.moveTo(0, y);
      } else {
        const oncekiX = (i - 1) * adim;
        const oncekiD = this.spectrumVerisi[i - 1] / 255;
        const oncekiY = h - oncekiD * h * 0.85;
        const cpx = (oncekiX + i * adim) / 2;
        ctx.bezierCurveTo(cpx, oncekiY, cpx, y, i * adim, y);
      }
    }
    ctx.strokeStyle = cizgiGrad;
    ctx.lineWidth = 2;
    ctx.shadowColor = '#4bf974';
    ctx.shadowBlur = 6;
    ctx.stroke();
    ctx.shadowBlur = 0;
  }

  // Mod 3: Dairesel spectrum
  private cizDairesel(ctx: CanvasRenderingContext2D, w: number, h: number) {
    const cx = w / 2;
    const cy = h / 2;
    const yaricap = Math.min(cx, cy) * 0.35;
    const sayisi = this.spectrumVerisi.length;

    for (let i = 0; i < sayisi; i++) {
      const d = this.spectrumVerisi[i] / 255;
      const aci = (i / sayisi) * Math.PI * 2 - Math.PI / 2;
      const icR = yaricap;
      const disR = yaricap + d * Math.min(cx, cy) * 0.55;

      const x1 = cx + Math.cos(aci) * icR;
      const y1 = cy + Math.sin(aci) * icR;
      const x2 = cx + Math.cos(aci) * disR;
      const y2 = cy + Math.sin(aci) * disR;

      const ton = (i / sayisi) * 120 + 100; // yeşil-mavi-mor
      ctx.beginPath();
      ctx.moveTo(x1, y1);
      ctx.lineTo(x2, y2);
      ctx.strokeStyle = `hsla(${ton}, 80%, 65%, ${0.4 + d * 0.6})`;
      ctx.lineWidth = Math.max(1, (Math.PI * 2 * yaricap) / sayisi - 0.5);
      ctx.lineCap = 'round';
      ctx.stroke();
    }

    // İç daire parıltısı
    const ortalama = this.spectrumVerisi.reduce((t, v) => t + v, 0) / sayisi / 255;
    const parlaklik = ctx.createRadialGradient(cx, cy, 0, cx, cy, yaricap);
    parlaklik.addColorStop(0, `rgba(75, 249, 116, ${ortalama * 0.4})`);
    parlaklik.addColorStop(1, 'rgba(75, 249, 116, 0)');
    ctx.fillStyle = parlaklik;
    ctx.beginPath();
    ctx.arc(cx, cy, yaricap, 0, Math.PI * 2);
    ctx.fill();
  }

  // Mod 4: Ayna (üst-alt simetrik dalga)
  private cizAyna(ctx: CanvasRenderingContext2D, w: number, h: number) {
    const sayisi = this.spectrumVerisi.length;
    const genislik = w / sayisi;
    const ortaY = h / 2;

    for (let i = 0; i < sayisi; i++) {
      const d = this.spectrumVerisi[i] / 255;
      const yukseklik = d * ortaY * 0.85;

      const ton = 140 + (i / sayisi) * 80;
      const alpha = 0.35 + d * 0.65;

      // Üst gradient
      const ustGrad = ctx.createLinearGradient(0, ortaY - yukseklik, 0, ortaY);
      ustGrad.addColorStop(0, `hsla(${ton}, 85%, 70%, ${alpha})`);
      ustGrad.addColorStop(1, `hsla(${ton}, 85%, 70%, ${alpha * 0.2})`);
      ctx.fillStyle = ustGrad;
      ctx.fillRect(i * genislik + 0.5, ortaY - yukseklik, genislik - 1, yukseklik);

      // Alt gradient (yansıma)
      const altGrad = ctx.createLinearGradient(0, ortaY, 0, ortaY + yukseklik);
      altGrad.addColorStop(0, `hsla(${ton}, 85%, 70%, ${alpha * 0.2})`);
      altGrad.addColorStop(1, `hsla(${ton}, 85%, 70%, ${alpha * 0.6})`);
      ctx.fillStyle = altGrad;
      ctx.fillRect(i * genislik + 0.5, ortaY, genislik - 1, yukseklik);
    }

    // Orta çizgi
    ctx.beginPath();
    ctx.moveTo(0, ortaY);
    ctx.lineTo(w, ortaY);
    ctx.strokeStyle = 'rgba(255, 255, 255, 0.08)';
    ctx.lineWidth = 1;
    ctx.stroke();
  }

  // Mod 5: Parçacık efekti
  private cizParcacik(ctx: CanvasRenderingContext2D, w: number, h: number) {
    const ortalama = this.spectrumVerisi.reduce((t, v) => t + v, 0) / this.spectrumVerisi.length / 255;
    const bass = this.spectrumVerisi.slice(0, 8).reduce((t, v) => t + v, 0) / 8 / 255;

    // Yeni parçacık üret (ses yoğunluğuna göre)
    const yeniAdet = Math.floor(ortalama * 6);
    for (let j = 0; j < yeniAdet; j++) {
      this.parcaciklar.push({
        x: w / 2,
        y: h / 2,
        hiz: 0.5 + bass * 3 + Math.random() * 2,
        boyut: 1 + Math.random() * 2.5,
        aci: Math.random() * Math.PI * 2,
        alpha: 0.6 + Math.random() * 0.4,
      });
    }

    // Limit
    if (this.parcaciklar.length > 200) {
      this.parcaciklar = this.parcaciklar.slice(-200);
    }

    // Guncelle ve ciz — splice yerine swap-and-pop ile O(1) silme
    let yazIdx = 0;
    for (let i = 0; i < this.parcaciklar.length; i++) {
      const p = this.parcaciklar[i];
      p.x += Math.cos(p.aci) * p.hiz;
      p.y += Math.sin(p.aci) * p.hiz;
      p.alpha -= 0.012;
      p.boyut *= 0.995;

      if (p.alpha <= 0 || p.x < -5 || p.x > w + 5 || p.y < -5 || p.y > h + 5) {
        continue; // olmus parcacigi atla
      }

      // Hayatta kalan parcacigi ciz
      const ton = 140 + (p.aci / (Math.PI * 2)) * 120;
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.boyut, 0, Math.PI * 2);
      ctx.fillStyle = `hsla(${ton}, 80%, 65%, ${p.alpha})`;
      ctx.fill();

      // Hayatta kalanlari basa topla (in-place compaction)
      if (yazIdx !== i) this.parcaciklar[yazIdx] = p;
      yazIdx++;
    }
    this.parcaciklar.length = yazIdx; // olmus parcaciklari kes

    // Merkez parıltısı
    const parlaklik = ctx.createRadialGradient(w / 2, h / 2, 0, w / 2, h / 2, 15 + bass * 20);
    parlaklik.addColorStop(0, `rgba(75, 249, 116, ${bass * 0.5})`);
    parlaklik.addColorStop(1, 'rgba(75, 249, 116, 0)');
    ctx.fillStyle = parlaklik;
    ctx.beginPath();
    ctx.arc(w / 2, h / 2, 15 + bass * 20, 0, Math.PI * 2);
    ctx.fill();
  }

  // Mod 6: Osiloskop - soldan sağa gerçek dalga formu çizgisi
  private osiloskopVerisi: Uint8Array<ArrayBuffer> = null;
  private cizOsiloskop(ctx: CanvasRenderingContext2D, w: number, h: number) {
    // Time domain verisi (dalga formu)
    if (!this.osiloskopVerisi) {
      this.osiloskopVerisi = new Uint8Array(this.analyser.frequencyBinCount);
    }
    this.analyser.getByteTimeDomainData(this.osiloskopVerisi);

    const sayisi = this.osiloskopVerisi.length;
    const adim = w / sayisi;
    const ortaY = h / 2;

    // Arka plan grid çizgileri
    ctx.strokeStyle = 'rgba(75, 249, 116, 0.06)';
    ctx.lineWidth = 0.5;
    for (let gy = 0; gy < 5; gy++) {
      const yy = (gy / 4) * h;
      ctx.beginPath();
      ctx.moveTo(0, yy);
      ctx.lineTo(w, yy);
      ctx.stroke();
    }
    for (let gx = 0; gx < 9; gx++) {
      const xx = (gx / 8) * w;
      ctx.beginPath();
      ctx.moveTo(xx, 0);
      ctx.lineTo(xx, h);
      ctx.stroke();
    }

    // Orta referans çizgisi
    ctx.beginPath();
    ctx.moveTo(0, ortaY);
    ctx.lineTo(w, ortaY);
    ctx.strokeStyle = 'rgba(75, 249, 116, 0.12)';
    ctx.lineWidth = 0.5;
    ctx.stroke();

    // Parlak glow çizgi (altta)
    ctx.beginPath();
    for (let i = 0; i < sayisi; i++) {
      const d = this.osiloskopVerisi[i] / 128.0; // 128 = sessiz orta
      const y = (d * ortaY);
      if (i === 0) {
        ctx.moveTo(0, y);
      } else {
        ctx.lineTo(i * adim, y);
      }
    }
    ctx.strokeStyle = 'rgba(75, 249, 116, 0.15)';
    ctx.lineWidth = 6;
    ctx.stroke();

    // Ana çizgi
    ctx.beginPath();
    for (let i = 0; i < sayisi; i++) {
      const d = this.osiloskopVerisi[i] / 128.0;
      const y = (d * ortaY);
      if (i === 0) {
        ctx.moveTo(0, y);
      } else {
        ctx.lineTo(i * adim, y);
      }
    }
    const grad = ctx.createLinearGradient(0, 0, w, 0);
    grad.addColorStop(0, '#4bf974');
    grad.addColorStop(0.5, '#00e5ff');
    grad.addColorStop(1, '#4bf974');
    ctx.strokeStyle = grad;
    ctx.lineWidth = 1.5;
    ctx.shadowColor = '#4bf974';
    ctx.shadowBlur = 8;
    ctx.stroke();
    ctx.shadowBlur = 0;
  }

  // Sesi yazıya çevir (Whisper STT) - verbose_json ile altyazı segmentleri alır
  async yaziyCevir(panelGoster: boolean = true) {
    if (this.transkriptYukleniyor || !this.url) return;

    this.transkriptYukleniyor = true;
    this.transkriptMetni = '';
    if (panelGoster) this.transkriptGoster = true;
    this.altyaziSegmentleri = [];
    this.aktifAltyazi = '';
    this.CD.detectChanges();

    try {
      // Ses dosyasını fetch ile indir
      const response = await fetch(this.url);
      const blob = await response.blob();

      // FormData oluştur
      const formData = new FormData();
      formData.append('file', blob, 'audio.wav');
      formData.append('language', 'tr'); // Türkçe varsayılan

      // Backend'e gönder (FikoYTCtx uyumlu: {durum, sonuc} formatında döner)
      const baseUrl = this.sunucuUrl || `https://${window.location.hostname}:9000`;
      const sonuc = await fetch(`${baseUrl}/fapiv1/whisper/transkript`, {
        method: 'POST',
        body: formData,
      });

      if (!sonuc.ok) {
        const hata = await sonuc.json().catch(() => ({}));
        this.transkriptMetni = `Hata: ${hata?.durum?.mesaj || hata?.hata || sonuc.statusText}`;
      } else {
        const cevap = await sonuc.json();
        // FikoYTCtx formatı: { durum: {...}, sonuc: { text, segments, ... } }
        const veri = cevap.sonuc || cevap;

        if (veri?.segments && veri.segments.length > 0) {
          // verbose_json: segment'leri altyazı olarak kaydet
          this.altyaziSegmentleri = veri.segments.map((s: any) => ({
            start: s.start,
            end: s.end,
            text: (s.text || '').trim()
          }));
          this.transkriptMetni = veri.text || this.altyaziSegmentleri.map(s => s.text).join(' ');
          this.altyaziAktif = true;
        } else {
          this.transkriptMetni = veri?.text || 'Metin bulunamadı';
        }
        this.transkriptHazir.emit({ metin: this.transkriptMetni, segmentler: this.altyaziSegmentleri });
      }
    } catch (e) {
      this.transkriptMetni = `Bağlantı hatası: ${e.message}`;
    }

    this.transkriptYukleniyor = false;
    this.CD.detectChanges();
  }

  // Altyazı toggle (açık/kapalı)
  altyaziToggle() {
    if (this.altyaziSegmentleri.length === 0 && !this.transkriptMetni) {
      // MongoDB'den mevcut transkript VE segmentler varsa Whisper'a gitme
      if (this.mevcutTranskript && this.mevcutSegmentler?.length > 0) {
        this.transkriptMetni = this.mevcutTranskript;
        this.altyaziSegmentleri = this.mevcutSegmentler;
        this.altyaziAktif = true;
        this.CD.detectChanges();
        return;
      }
      // Segmentler yoksa (eski kayıt veya hiç yapılmamış) tekrar Whisper'a gönder
      this.yaziyCevir(false);
      return;
    }
    this.altyaziAktif = !this.altyaziAktif;
    if (!this.altyaziAktif) {
      this.aktifAltyazi = '';
    }
    this.CD.detectChanges();
  }

  // ontimeupdate'de çağrılır - aktif zamana göre altyazıyı günceller
  private altyaziGuncelle() {
    if (!this.altyaziAktif || this.altyaziSegmentleri.length === 0) return;

    const t = this.aktifZaman;
    const segment = this.altyaziSegmentleri.find(s => t >= s.start && t <= s.end);
    const yeniMetin = segment ? segment.text : '';

    if (yeniMetin !== this.aktifAltyazi) {
      this.aktifAltyazi = yeniMetin;
    }
  }

  transkriptKapat() {
    this.transkriptGoster = false;
    this.CD.detectChanges();
  }

  zamanKaydirildi($event: any) {
    if (this.sesObje) {
      this.sesObje.currentTime = $event.target.value;
      this.zamanKaydiriliyor = false;
    }
  }

  sessizTiklandi() {
    this.sessiz = !this.sessiz;
    if (this.sesObje) {
      this.sesObje.volume = this.sessiz ? 0 : this.sesSeviyesi;
    }
    this.CD.detectChanges();
  }

  sesSeviyesiDegisti($event: any) {
    this.sesSeviyesi = parseFloat($event.target.value);
    this.sessiz = this.sesSeviyesi === 0;
    if (this.sesObje) {
      this.sesObje.volume = this.sesSeviyesi;
    }
    this.CD.detectChanges();
  }

  ngOnDestroy(): void {
    if (this.animFrameId) {
      cancelAnimationFrame(this.animFrameId);
      this.animFrameId = null;
    }
    // AudioContext kaynaklarini serbest birak
    if (this.sourceNode) {
      try { this.sourceNode.disconnect(); } catch (_) {}
      this.sourceNode = null;
    }
    if (this.analyser) {
      try { this.analyser.disconnect(); } catch (_) {}
      this.analyser = null;
    }
    if (this.audioContext) {
      this.audioContext.close().catch(() => {});
      this.audioContext = null;
    }
    // Ses objesini temizle
    if (this.sesObje) {
      this.sesObje.pause();
      this.sesObje.removeAttribute('src');
      this.sesObje.load(); // buffer'lari serbest birakir
      this.sesObje = null;
    }
    // Spectrum verilerini temizle
    this.spectrumVerisi = null;
    this.osiloskopVerisi = null;
    this.parcaciklar = [];
  }
}
